// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementDiscountDTO from './subBubbleAgreementDiscountDTO'

export default class CreateSubBubbleAgreementDTO {
  constructor({
    clientId,
    clientGroupId,
    startDateLocal,
    endDateLocal,
    discounts,
  } = {}) {
    /**
     * @type {Number}
     */
    this.clientId = clientId
    /**
     * @type {Number}
     */
    this.clientGroupId = clientGroupId
    /**
     * @type {Date}
     */
    this.startDateLocal = startDateLocal
    /**
     * @type {Date}
     */
    this.endDateLocal = endDateLocal
    /**
     * @type {SubBubbleAgreementDiscountDTO[]}
     */
    this.discounts = discounts
  }
}
